import React from 'react';
import { formatCredits } from '@/utils/formatCredits';
import ZapIcon from '@/shared/icons/ZapIcon';
import { useUserStore } from '@/stores/user/userStore';

const CreditsAndUpgrade = ({ used, total, onUpgrade }) => {
  if (used == null || total == null) return null;

  const isDemoAccount = useUserStore((state) => state.user?.is_demo_account);

  if (isDemoAccount !== false) {
    return null;
  }

  const percentage = total > 0 ? (used / total) * 100 : 0;
  const isWarning = percentage >= 80;
  const barColor = isWarning ? 'bg-v3-orange-primary' : 'bg-v3-purple-primary';
  const borderColor = isWarning ? 'border-v3-orange-border' : 'border-v3-neutral-border';
  const bgColor = isWarning ? 'bg-v3-orange-bg' : 'bg-v3-neutral-bg';

  return (
    <>
      <div className={`flex flex-col items-start gap-v3-ms rounded-v3-ms border ${borderColor} ${bgColor} p-v3-sm`}>
        <div className="flex flex-col">
          <span className="text-v3-black-max text-v3-h10 font-medium pb-[2px]">Credits</span>
          <span className={`text-v3-h11 font-medium ${isWarning ? 'text-v3-orange-darker' : 'text-v3-black-secondary'}`}>
            {formatCredits(used)} / {formatCredits(total)}
          </span>
        </div>
        <div className="w-full h-[6px] bg-v3-neutral-border rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-300 ${barColor}`}
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
      </div>
      <button
        type="button"
        onClick={onUpgrade}
        className="flex items-center justify-between gap-v3-xs w-full rounded-v3-ms border border-[#262624] bg-[#181817] px-v3-ms py-v3-xs hover:bg-[#1a1a1a] transition-colors"
      >
        <div className="flex flex-col items-start gap-[2px]">
          <span className="text-v3-h10 font-bold font-inter-variable text-[#fff]">Upgrade</span>
          <span className="text-[11px] font-normal font-inter-variable text-v3-black-placeholder">Unlock more benefits</span>
        </div>
        <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#2b2a47] flex items-center justify-center">
          <ZapIcon className="w-4 h-4 text-[#fff]" fill="white" />
        </div>
      </button>
    </>
  );
};

export default CreditsAndUpgrade;
